export interface Experience {
  id: number;
  title: string;
  company: string;
  period: string;
  location: string;
  description: string;
  technologies: string[];
  type: "alternance" | "stage" | "freelance" | "projet";
  logo?: string;
  achievements?: string[];
}

export const experiences: Experience[] = [
  {
    id: 1,
    title: "Développeur web - Front",
    company: "Splash360",
    period: "Décembre 2022 - Présent",
    location: "Paris, France",
    description:
      "Alternance en développement web sur des applications complexes de gestion multi-restaurants. J'ai contribué à la conception d'interfaces, ajouté de nouvelles fonctionnalités et amélioré l'expérience utilisateur.",
    technologies: ["React", "TypeScript", "Tailwind CSS", "ShadCN", "Electron"],
    type: "alternance",
    achievements: [
      "Développement du backoffice des gestion des restaurants avec React, TypeScript, Tailwind CSS, ShadCN (frontend) et Java (backend)",
      "Création de fonctionnalités avancées : gestion multi-restaurants, catalogues produits, TVA, personnalisation menus, configuration terminaux/caisses",
      "Collaboration transversale avec les équipes techniques et chefs de projet",
      "Amélioration des outils existants : refactorisation d'interfaces avec Electron et React",
      "Conception et développement d'application de fidélité clients (Angular Material, Tailwind CSS)",
    ],
  },
  {
    id: 2,
    title: "Développeur web - Fullstack",
    company: "SocialApp - Réseau social moderne (V1)",
    period: "Juin 2025",
    location: "Projet Personnel",
    description:
      "Développement d'un réseau social moderne avec authentification sécurisée, comptes invités automatiques et fonctionnalités complètes de publication et interaction.",
    technologies: [
      "React",
      "Redux",
      "Tailwind CSS",
      "Node.js",
      "Express",
      "MongoDB",
      "Docker",
    ],
    type: "projet",
    achievements: [
      "Authentification sécurisée avec comptes invités automatiques",
      "Fonctionnalités complètes : publication, like, commentaire, follow/unfollow, édition profil",
      "Déploiement Docker complet avec HTTPS sur VPS OVH",
      "Site accessible : social-app.jeanbeguerisse.com",
      "Architecture fullstack moderne et scalable",
    ],
  },
  {
    id: 3,
    title: "Stage, Développeur web - Front",
    company: "MédiaLink Network",
    period: "Mai 2022 - Juin 2022",
    location: "Paris, France",
    description:
      "Stage en développement web frontend avec focus sur la création et gestion de sites web avec WordPress.",
    technologies: ["WordPress", "HTML/CSS", "Gestion de contenu"],
    type: "stage",
    achievements: [
      "Développement et gestion de sites web",
      "Utilisation de WordPress pour la création de contenu",
      "Maîtrise des technologies HTML/CSS",
      "Approche projet et travail en équipe",
    ],
  },
  {
    id: 4,
    title: "Développeur web",
    company: "DTECH",
    period: "Octobre - Novembre 2019",
    location: "Dakar, Sénégal",
    description:
      "Conception d'une application web pour la gestion des inscriptions scolaires avec implémentation de base de données.",
    technologies: ["PHP RAD", "MySQL", "Gestion de base de données"],
    type: "stage",
    achievements: [
      "Conception d'application web pour gestion des inscriptions scolaires",
      "Utilisation de PHP RAD pour le développement rapide",
      "Implémentation de base de données avec PHP MySQL",
      "Approche projet et développement d'applications métier",
    ],
  },
];

// Fonction pour obtenir les couleurs par type d'expérience
export const getTypeColor = (type: string) => {
  switch (type) {
    case "alternance":
      return "from-blue-500 to-blue-600 dark:from-blue-400 dark:to-blue-500";
    case "stage":
      return "from-green-500 to-green-600 dark:from-green-400 dark:to-green-500";
    case "freelance":
      return "from-purple-500 to-purple-600 dark:from-purple-400 dark:to-purple-500";
    case "projet":
      return "from-orange-500 to-orange-600 dark:from-orange-400 dark:to-orange-500";
    default:
      return "from-gray-500 to-gray-600 dark:from-gray-400 dark:to-gray-500";
  }
};

// Fonction pour obtenir les labels par type d'expérience
export const getTypeLabel = (type: string) => {
  switch (type) {
    case "alternance":
      return "Alternance";
    case "stage":
      return "Stage";
    case "freelance":
      return "Freelance";
    case "projet":
      return "Projet Personnel";
    default:
      return type;
  }
};
